import React, { useEffect, useState } from 'react';
import { Container, Button, Nav } from 'react-bootstrap';
import { Box } from '@mui/material';
import Navbar from 'react-bootstrap/Navbar';
import { LinkContainer } from 'react-router-bootstrap'

const Header = () => {
  const [animate, setAnimate] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setAnimate(true); // Trigger animation on load
  }, []);

  const loginButtonStyle = {
    backgroundColor: isHovered ? '#D6D58E' : '#005C53',
    color: isHovered ? 'black' : 'white',
    border: 'none',
    padding: '8px 20px',
    fontWeight: 'bold',
    borderRadius: '4px',
    transition: 'all 0.3s ease'
  };

  return (
    // <Box
    //   className={`header-wrapper ${animate ? 'fade-in' : ''}`}
    //   style={{ backgroundColor: '#A6CE39' }}
    // >
    //   <Container
    //     fluid
    //     className="header-container d-flex justify-content-between align-items-center py-3"
    //   >
    //     {/* Logo + Tagline */}
    //     <Box className="branding-wrapper d-flex align-items-center px-3">
    //       <img
    //         src={require("../Images/Logo Tick.png")}
    //         alt="Logo"
    //         className="branding-logo"
    //         style={{ height: '60px', width: '80px' }}
    //       />
    //       {/* <img
    //         src={require("../Images/Name and Tagline.png")}
    //         alt="ValueFundz Tagline"
    //         className="branding-tagline ms-3"
    //         style={{ height: '40px' }}
    //       /> */}
    //       {/* ValueFundz */}
    //     </Box>
    //     <LinkContainer to = '/'>
    //                 <Navbar.Brand>Turing</Navbar.Brand>
    //             </LinkContainer>

    //     {/* Login Button */}
    //     <Button
    //       as="a"
    //       href="https://valuefundz.investwell.app/"
    //       style={loginButtonStyle}
    //       onMouseEnter={() => setIsHovered(true)}
    //       onMouseLeave={() => setIsHovered(false)}
    //     >
    //       Login
    //     </Button>
    //   </Container>
    // </Box>
//     <header>
//         <Navbar expand="lg" collapseOnSelect style={{ backgroundColor: '#A6CE39' }}>
//   <Container className="d-flex justify-content-between align-items-center">

//     {/* Left Section: Logo + Brand Name */}
//     <div className="d-flex align-items-center">
//        <Box className="branding-wrapper d-flex align-items-center px-3">
//          <img
//             src={require("../Images/Logo Tick.png")}
//             alt="Logo"
//             className="branding-logo"
//             style={{ height: '60px', width: '80px' }}
//           />
          
//         </Box>
//       <LinkContainer to="/">
//         <Navbar.Brand className="fw-bold">VALUEFUNDZ</Navbar.Brand>
//       </LinkContainer>
//     </div>

//     {/* Middle Section: Tagline */}
//     <Navbar.Brand className="mx-auto fw-semibold">
//       रखे ख़याल आपके <span style={{ fontWeight: 'bold' }}>INVESTMENT</span> का
//     </Navbar.Brand>

//     {/* Right Section: Login Button */}
//     <Button
//       as="a"
//       href="https://valuefundz.investwell.app/"
//       style={loginButtonStyle}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//     >
//       Login
//     </Button>
//   </Container>
// </Navbar>

//     </header>

<header>
  <Navbar expand="lg" collapseOnSelect style={{ backgroundColor: '#A6CE39' }}>
    <Container
      className="align-items-center"
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center',
      }}
    >
      {/* Left Section: Logo + Brand */}
      <div className="d-flex align-items-center">
        <Box className="branding-wrapper d-flex align-items-center px-3">
          <img
            src={require("../Images/Logo Tick.png")}
            alt="Logo"
            className="branding-logo"
            style={{ height: '60px', width: '80px' }}
          />
        </Box>
        <LinkContainer to="/">
          <Navbar.Brand className="fw-bold fs-2 text-white">VALUEFUNDZ</Navbar.Brand>
        </LinkContainer>
      </div>

      {/* Center Section: Tagline */}
      <div className="text-center">
        <Navbar.Brand className="fw-semibold text-white m-0">
          रखे ख़याल आपके <span style={{ fontWeight: 'bold' }}>INVESTMENT</span> का
        </Navbar.Brand>
      </div>

      {/* Right Section: Login */}
      <div className="d-flex justify-content-end">
        <Button
          as="a"
          href="https://valuefundz.investwell.app/"
          style={loginButtonStyle}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          Login
        </Button>
      </div>
    </Container>
  </Navbar>
</header>

  );
};

export default Header;
